import FormData from 'form-data';
import {capitalizeWords} from "../../utils/GenericUtils";
import {codiciPostaliComuni} from "../../utils/arrays/CodiciPostaliComuni";
import moment from "moment";
import {getArrayOf} from "./IntervistaApiData";
import {attivitaETS} from "../../utils/arrays/AttivitaETS";

export function getanagraficaBaseApiData(data) {
	return {
		...data,
		codF: data.codF.toUpperCase(),
		cell: data.cell.trim().replace(/\D+/g, ''),
		fax: data.fax ? data.fax.trim().replace(/\D+/g, '') : "",
		nome: capitalizeWords(data.nome),
		cognome: capitalizeWords(data.cognome),
	};
}

export function getRegistPazienteApiData(data) {
	return {
		codF: data.codF.toUpperCase(),
		cell: data.cell.trim().replace(/\D+/g, ''),
		nome: capitalizeWords(data.nome),
		cognome: capitalizeWords(data.cognome),
		sesso: data.sesso,
		dataNascita: data.dataNascita,
		email: data.email,
		indirizzoDomicilio: data.indirizzoDomicilio,
		indirizzoResidenza: data.indirizzoResidenza
	};
}

export function getRegistReferenteCompanyApiData(data) {
	return {
		...data,
		codF: data.codF.toUpperCase(),
		cell: data.cell.trim().replace(/\D+/g, ''),
		nome: capitalizeWords(data.nome),
		cognome: capitalizeWords(data.cognome),
		sesso: data.sesso,
		dataNascita: data.dataNascita,
		email: data.email,
		indirizzoDomicilio: data.indirizzoDomicilio,
		indirizzoResidenza: data.indirizzoResidenza,
		role: data.role,
	};
}

export function getLoginPazienteApiData(data) {
	return {
		codF: data.codF,
		password: data.password
	}
}

export function getFileData(data, fileName, index = 0) {
	let formData = new FormData();
	formData.append(fileName, data[index]);
	const nameStr = new Blob([JSON.stringify(data[index]?.name).trim()], {type: 'application/json'});
	formData.append('name', nameStr);
	return formData;
}

export function getAddAllegatoData(allegato) {
	let formData = new FormData();
	formData.append("allegato", allegato);
	const nameStr = new Blob([allegato?.name], {type: 'application/json'});
	formData.append('name', nameStr);
	return formData;
}

export function getSmsMailData(data) {
	let formData = new FormData();
	formData.append("file", data.csv?.[0]);
	const messageStr = new Blob([JSON.stringify(data)], {type: 'application/json'});
	formData.append('message', messageStr);
	return formData;
}

export function getSirvaCsv(data, name = "csv") {
	let formData = new FormData();
	formData.append("csv", data[name][0]);
	return formData;
}

export function getProtocolloData(data) {
	let formData = new FormData();
	formData.append("ProtocolloPDF", data.ProtocolloPDF?.[0]);
	delete data.ProtocolloPDF;
	const protocolloStr = new Blob([JSON.stringify(data)], {type: 'application/json'});
	formData.append('ProtocolloDTO', protocolloStr);
	return formData;
}

export function sollecitaTicketApi(ticket) {
	let newPriority;
	if (ticket.priority === "Bassa") {
		newPriority = "Media";
	} else if (ticket.priority === "Media") {
		newPriority = "Alta";
	} else if (ticket.priority === "Alta") {
		newPriority = "Urgente";
	} else {
		newPriority = "Urgente"
	}

	return {
		...ticket,
		note: "#SOLLECITO " + ticket.note,
		stato: ticket.stato === "Risolto" ? "Aperto" : ticket.stato,
		priority: newPriority
	}
}

export function getETSApiData(data) {
	return {
		cognome: capitalizeWords(data.cognome),
		nome: capitalizeWords(data.nome),
		mail: data.email,
		cell: data.cell?.replace(/\D/g, ''),
		dataNascita: moment(new Date(data.dataNascita)).format("DD/MM/YYYY"),
		comuneNascita: getComuneNascitaItem(data.comuneNascita),
		indirizzo: data.indirizzo + " , " + data?.cittaLegale + " , " + data?.capLegale,
		documento: data.documento?.toUpperCase(),
		allegati: data.allegato,
		attivitaSvolte: getValueArray(getArrayOf(Object.keys(attivitaETS), data), attivitaETS),
		nomeAssociazione: data.nomeAssociazione,
		dataCostituzione: moment(new Date(data.dataCostituzione)).format("DD/MM/YYYY"),
		sitoAssociazione: data.sitoAssociazione,
		pec: data.pec,
		cellAssociazione: data.cellAssociazione,
		sedeLegale: data.sedeLegale + " , " + data?.capSedeLegale,
		comuneSedeLegale: data.comuneSedeLegale,
		sedeOperativa: data.sedeOperativa,
		capSedeOperativa: data.capSedeOperativa,
		relazioneAttivita: data.relazioneAttivita,
		documentoAssociazione: data.documentoAssociazione
	};
}

function getComuneNascitaItem(comuneString) {
	if (!comuneString) {
		return "ERR 621218";
	}
	for (const item of codiciPostaliComuni) {
		if (item.replaceAll(" ", "").includes(comuneString.replaceAll(" ", ""))) return item;
	}
	return comuneString;
}

function getValueArray(array1, dict) {
	let result = [];
	array1.forEach(item => {
		if (dict[item]) {
			result.push(dict[item]?.value)
		}
	})
	return result.join(",");
}
